import { z } from 'zod';

export const booleanOperators = z.enum(['eq', 'null', 'notnull']);

export const datetimeOperators = z.enum(['eq', 'null', 'notnull', 'gt', 'lt', 'in']);

export const picklistOperators = z.enum(['eq', 'in', 'null', 'notnull']);

export const customFieldPicklistOperators = z.enum(['eq', 'in', 'notIn', 'null', 'notnull']);

export const stringOperators = z.enum([
  'eq',
  'in',
  'ne',
  'containsIgnoreCase',
  'startsWithIgnoreCase',
]);

// Only the Text custom-field-filter type supports notContainsIgnoreCase/null/notnull today —
// keep it separate from `stringOperators`, which is also shared by standard item filters
// (name, externalKey, quickFilters, descendant.statusItemStatusType) and Link custom fields,
// none of which support this operator set.
export const textCustomFieldOperators = z.enum([
  'containsIgnoreCase',
  'notContainsIgnoreCase',
  'eq',
  'null',
  'notnull',
]);

// `in` means "between" (a 2-value range), matching the datetimeOperators convention.
export const numericOperators = z.enum([
  'eq',
  'ne',
  'gt',
  'ge',
  'lt',
  'le',
  'in',
  'null',
  'notnull',
]);

export type DateOperator = z.infer<typeof datetimeOperators>;
export type PicklistOperator = z.infer<typeof picklistOperators>;
export type CustomFieldPicklistOperator = z.infer<typeof customFieldPicklistOperators>;
export type StringOperator = z.infer<typeof stringOperators>;
export type BooleanOperator = z.infer<typeof booleanOperators>;
export type TextCustomFieldOperator = z.infer<typeof textCustomFieldOperators>;
export type NumericOperator = z.infer<typeof numericOperators>;
